import { testimonials, contact } from "@/mocks/gossip";
import SectionHead from "./SectionHead";

export default function About() {
  return (
    <section id="about" className="relative scroll-mt-24 py-10 md:py-14">
      <div className="mx-auto max-w-[1400px] px-4 md:px-6">
        <SectionHead
          kicker="关于我们 · 瓜田口碑"
          title="一家只想把瓜讲明白的速递媒体"
          desc="没有标题党，没有二手猜测。吃瓜前线专注一手核实与清晰表达，让每个热点都经得起推敲。"
        />

        <div className="mt-8 grid grid-cols-1 gap-5 md:grid-cols-4">
          <div className="rounded-2xl border border-stone-200 bg-white p-6 md:col-span-2 md:p-7">
            <span className="inline-flex items-center gap-1.5 rounded-full bg-brand-50 px-3 py-1 text-[12px] font-semibold text-brand-700">
              <i className="ri-focus-3-line" />
              我们是谁
            </span>
            <h3 className="mt-4 font-heading text-[20px] font-bold leading-snug text-[#241b13]">
              {contact.intro}
            </h3>
            <p className="mt-3 text-[14px] leading-relaxed text-stone-500">
              定位很简单：做华语网络里最靠谱的那只"猹"。我们不上来就下结论，而是把独家线索、
              首发片段与官方回应放在同一条时间线上，让每一个吃瓜的人都能看到全景，而不是被牵着鼻子走。
            </p>
            <div className="mt-5 grid grid-cols-2 gap-3 sm:grid-cols-4">
              {[
                { n: "26 位", l: "前线编辑" },
                { n: "40+", l: "全网合作线人" },
                { n: "99.2%", l: "事实核实率" },
                { n: "7×24", l: "滚动盯热点" },
              ].map((s) => (
                <div key={s.l} className="rounded-xl bg-stone-50 p-3 text-center">
                  <p className="font-heading text-[19px] font-black text-brand-600">{s.n}</p>
                  <p className="mt-0.5 text-[11px] text-stone-500">{s.l}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 md:col-span-2">
            {[
              { icon: "ri-eye-off-line", t: "拒绝网暴", d: "涉及个人隐私与名誉的内容一律谨慎核实，不放大、不拱火。" },
              { icon: "ri-quill-pen-line", t: "写作克制", d: "用冷静笔触讲清楚事实与来龙去脉，把情绪留给评论区，把逻辑留给正文。" },
              { icon: "ri-git-branch-line", t: "持续追踪", d: "热点不会一次讲完。事件有进展，我们就持续补全，形成完整时间线。" },
              { icon: "ri-community-line", t: "开放共创", d: "线索来自全网读者。你的投稿经核实即可上版，吃瓜也要一起才热闹。" },
            ].map((v) => (
              <div key={v.t} className="rounded-2xl border border-stone-200 bg-white p-5">
                <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-brand-100 text-brand-600">
                  <i className={v.icon + " text-lg"} />
                </span>
                <h4 className="mt-3 font-heading text-[16px] font-bold text-[#241b13]">{v.t}</h4>
                <p className="mt-1.5 text-[13px] leading-relaxed text-stone-500">{v.d}</p>
              </div>
            ))}
          </div>
        </div>

        {/* 用户口碑 */}
        <div className="mt-10 grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4">
          {testimonials.map((t, i) => (
            <figure
              key={t.name}
              className="flex flex-col rounded-2xl border border-stone-200 bg-white p-5"
            >
              <div className="flex items-center gap-0.5 text-gold-500">
                {Array.from({ length: 5 }).map((_, j) => (
                  <i key={j} className="ri-star-fill text-[13px]" />
                ))}
              </div>
              <blockquote className="mt-3 flex-1 text-[14px] leading-relaxed text-stone-700">
                " {t.quote} "
              </blockquote>
              <figcaption className="mt-4 flex items-center gap-3">
                <span className="flex h-9 w-9 items-center justify-center rounded-full bg-brand-500 text-[13px] font-bold text-white">
                  {t.name.charAt(0)}
                </span>
                <span className="flex flex-col">
                  <span className="text-[13px] font-semibold text-[#241b13]">{t.name}</span>
                  <span className="text-[11px] text-stone-400">{t.role}</span>
                </span>
                <i className="ri-double-quotes-r ml-auto text-lg text-stone-200" />
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}